import { each, equals2 } from "fxjs/es";
import { VONS } from "../../VO/VONS.js";
export class SelectorCircleView {
  constructor({
    r_circle_d,
    transparent_d,
    selector_r_circle_el,
    selector_n_circle_el,
    selector_ne_circle_el,
    selector_e_circle_el,
    selector_se_circle_el,
    selector_s_circle_el,
    selector_sw_circle_el,
    selector_w_circle_el,
    selector_nw_circle_el,
  }) {
    this._r_circle_d = r_circle_d;
    this._transparent_d = transparent_d;
    this._selector_r_circle_el = selector_r_circle_el;
    this._selector_n_circle_el = selector_n_circle_el;
    this._selector_ne_circle_el = selector_ne_circle_el;
    this._selector_e_circle_el = selector_e_circle_el;
    this._selector_se_circle_el = selector_se_circle_el;
    this._selector_s_circle_el = selector_s_circle_el;
    this._selector_sw_circle_el = selector_sw_circle_el;
    this._selector_w_circle_el = selector_w_circle_el;
    this._selector_nw_circle_el = selector_nw_circle_el;
  }
  observeSelectorController({
    is_show,
    mode,
    scale_type,
    n_point,
    ne_point,
    e_point,
    se_point,
    s_point,
    sw_point,
    w_point,
    nw_point,
  }) {
    const [r_point_x, r_point_y] = (() => {
      const vertical_vec = [n_point.x - s_point.x, n_point.y - s_point.y];
      const horizontal_vec = [ne_point.x - nw_point.x, ne_point.y - nw_point.y];
      const vertical_vec_length = Math.sqrt(
        vertical_vec[0] ** 2 + vertical_vec[1] ** 2
      );
      const horizontal_vec_length = Math.sqrt(
        horizontal_vec[0] ** 2 + horizontal_vec[1] ** 2
      );
      if (vertical_vec_length > 0) {
        const vec = [
          (vertical_vec[0] / vertical_vec_length) * this._r_circle_d,
          (vertical_vec[1] / vertical_vec_length) * this._r_circle_d,
        ];
        return [n_point.x + vec[0], n_point.y + vec[1]];
      }
      if (horizontal_vec_length > 0) {
        const vec = [
          (horizontal_vec[1] / horizontal_vec_length) * this._r_circle_d,
          (-horizontal_vec[0] / horizontal_vec_length) * this._r_circle_d,
        ];
        return [n_point.x + vec[0], n_point.y + vec[1]];
      }
      return [n_point.x, n_point.y];
    })();
    const is_rotate = equals2(mode)("ROTATE");
    const is_only_translate = equals2(mode)("ONLY_TRANSLATE");
    const is_all_scalable = equals2(scale_type)("ALL");
    const opacity = (() => {
      const width_sqr =
        (w_point.x - e_point.x) ** 2 + (w_point.y - e_point.y) ** 2;
      const height_sqr =
        (n_point.x - s_point.x) ** 2 + (n_point.y - s_point.y) ** 2;
      const opacity = Math.max(
        Math.min(Math.min(width_sqr, height_sqr) / this._transparent_d ** 2, 1),
        0.1
      );
      return `${opacity}`;
    })();
    each(([el, x, y, is_show]) => {
      el.style.display = is_show ? "" : "none";
      el.style.opacity = opacity;
      el.setAttributeNS(null, "transform", `translate(${x} ${y})`);
    })([
      [
        this._selector_n_circle_el,
        n_point.x,
        n_point.y,
        is_show && !is_rotate && is_all_scalable && !is_only_translate,
      ],
      [
        this._selector_ne_circle_el,
        ne_point.x,
        ne_point.y,
        is_show && !is_rotate && !is_only_translate,
      ],
      [
        this._selector_e_circle_el,
        e_point.x,
        e_point.y,
        is_show && !is_rotate && is_all_scalable && !is_only_translate,
      ],
      [
        this._selector_se_circle_el,
        se_point.x,
        se_point.y,
        is_show && !is_rotate && !is_only_translate,
      ],
      [
        this._selector_s_circle_el,
        s_point.x,
        s_point.y,
        is_show && !is_rotate && is_all_scalable && !is_only_translate,
      ],
      [
        this._selector_sw_circle_el,
        sw_point.x,
        sw_point.y,
        is_show && !is_rotate && !is_only_translate,
      ],
      [
        this._selector_w_circle_el,
        w_point.x,
        w_point.y,
        is_show && !is_rotate && is_all_scalable && !is_only_translate,
      ],
      [
        this._selector_nw_circle_el,
        nw_point.x,
        nw_point.y,
        is_show && !is_rotate && !is_only_translate,
      ],
      [
        this._selector_r_circle_el,
        r_point_x,
        r_point_y,
        is_show && !is_only_translate,
      ],
    ]);
  }
}
